import type { ComponentType } from "react";
import type { MdxComponentName } from "@rounak-portfolio/shared";
import { ClumpBars } from "./ClumpBars";
import { GCVisualizer } from "./GCVisualizer";
import { IntervalPlot } from "./IntervalPlot";
import { PairedGrid } from "./PairedGrid";
import { PassGrid } from "./PassGrid";
import { PowerCurve } from "./PowerCurve";
import { StepStrip } from "./StepStrip";
import { SweepTimeline } from "./SweepTimeline";

export { Markdown } from "./Markdown";

// Render map for interactive components referenced by name in compiled MDX
// output (`_components.GCVisualizer`, etc). Typed against
// packages/shared/src/mdx-components.ts's MdxComponentName so registering a
// name there without a real implementation here fails `tsc`, per that
// file's header comment.
export const mdxComponents = {
  GCVisualizer,
  StepStrip,
  PassGrid,
  SweepTimeline,
  IntervalPlot,
  ClumpBars,
  PairedGrid,
  PowerCurve,
} satisfies Record<MdxComponentName, ComponentType<any>>;
